import { ApiService } from '@b2b/common/services/api/types';
import uiRouter, { StateParams, StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { MembershipDataResolver } from '../resolvers';
import { MembershipDetailControllerModule } from './controllers/MembershipDetailController';
import { MembershipDetailMemberView } from './member/member';

export const MembershipDetailView = angular
  .module('acme.view.application.membership.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.detailList',
    MembershipDetailControllerModule,
    MembershipDetailMemberView,
  ])

  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.membership.detail',
      url: '/:id/detail?searchName',
      views: {
        'subview-main': {
          controller: 'MembershipDetailController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/membership/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Membership Details',
        enablePreferences: true,
      },
      resolve: {
        SubscriptionData: [
          '$stateParams',
          'ApiService',
          function ($stateParams: StateParams, ApiService: ApiService) {
            return ApiService.subscriptions.detail($stateParams.id).catch(() => {
              // We return null if the user doesn't have sub details so that portion is not painted
              return { data: null };
            });
          },
        ],
        MembershipData: MembershipDataResolver(),
      },
    });
  }).name;
